import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Loader2, Radar } from "lucide-react";

// Progress popup shown while a market/price scan is running. Uses a time-based
// estimate (default ~90s) with a smooth bar + remaining countdown; snaps to 100%
// when `running` turns false.
export default function ScanProgressModal({ running, lang = "it", estSeconds = 90, title }) {
  const L = (it, en) => (lang === "en" ? en : it);
  const [pct, setPct] = useState(0);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!running) { setPct(100); return; }
    setPct(0); setElapsed(0);
    const start = Date.now();
    const id = setInterval(() => {
      const s = (Date.now() - start) / 1000;
      setElapsed(s);
      // ease toward 95% over estSeconds, never reaching 100 until done
      setPct(Math.min(95, Math.round((1 - Math.exp(-s / (estSeconds / 3))) * 100)));
    }, 400);
    return () => clearInterval(id);
  }, [running, estSeconds]);

  const remaining = Math.max(0, Math.round(estSeconds - elapsed));
  return (
    <Dialog open={running}>
      <DialogContent className="max-w-md" data-testid="scan-progress-modal">
        <div className="flex items-center gap-3 mb-3">
          <div className="relative"><Radar className="w-6 h-6 text-primary" /><Loader2 className="w-6 h-6 text-primary/40 animate-spin absolute inset-0" /></div>
          <div>
            <h3 className="font-semibold">{title || L("Analisi del mercato in corso", "Analyzing the market")}</h3>
            <p className="text-xs text-muted-foreground">{L("Sto interrogando i tuoi competitor su Booking…", "Querying your competitors on Booking…")}</p>
          </div>
        </div>
        <div className="h-3 rounded-full bg-secondary overflow-hidden">
          <div className="h-full bg-primary transition-all duration-300 ease-out rounded-full" style={{ width: `${pct}%` }} data-testid="scan-progress-bar" />
        </div>
        <div className="flex items-center justify-between mt-2 text-xs">
          <span className="font-data font-bold text-primary" data-testid="scan-progress-pct">{pct}%</span>
          <span className="text-muted-foreground" data-testid="scan-progress-eta">
            {remaining > 0 ? L(`~${remaining}s rimanenti`, `~${remaining}s remaining`) : L("Quasi finito…", "Almost done…")}
          </span>
        </div>
        <p className="text-[11px] text-muted-foreground mt-3">{L("Puoi attendere qui: i dati verranno salvati e riutilizzati per 24h in tutte le sezioni.", "You can wait here: data will be saved and reused for 24h across all sections.")}</p>
      </DialogContent>
    </Dialog>
  );
}
